module.exports = __webpack_public_path__ + "img/108.5.e4014718.png";